import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/report/customers";

export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const chart = async (filter) => {
  return await axiosInstance(options).get(`${path}?filter=${filter}`);
};
